var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Header',{attrs:{"active":2}}),_c('Partner',{staticClass:"anli-partner",attrs:{"showDot":true,"title":'电影/电视/动画云渲染'}}),_c('ItemList'),_c('Position'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }